/* eslint-disable lingui/no-unlocalized-strings */
import { HttpError } from '@/utils/error/HttpError';

export class NotFoundError extends HttpError {
  constructor(message?: string) {
    super(message ?? 'Not found', 404);
    this.name = 'NotFoundError';
  }
}
